import type { OverWritable } from '../../@types/settings';

export const container: OverWritable = {
  MuiContainer: {
    styleOverrides: {
      root: {
        paddingLeft: 20,
        paddingRight: 20,
      },
    },
  },
};
